<div class="relative h-full w-[278px] bg-pl-gray-700 text-white">
  <div *ngIf="levels()">
    <pl-menu-item
      *ngFor="let level of levels()"
      class="block w-full border-y border-white"
      [backgroundColor]="level | menuItemBackgroundColor: routeSlugs()"
      [iconLeft]="level.menuItem.iconLeft"
      [iconLeftColor]="level.menuItem.iconLeftColor"
      [iconRight]="level | menuItemChevron: routeSlugs()"
      [isLocked]="level.menuItem.isLocked"
      [orangeSubtitle]="level.menuItem.orangeSubtitle"
      [subtitle]="level.menuItem.subtitle"
      [title]="level.menuItem.title"
      (click)="showModules(level.modules)"
    />

    <ng-container *ngTemplateOutlet="menuItemLogout" />
  </div>

  <div @translateX *ngIf="modulesForDisplay().length !== 0" class="absolute bottom-0 top-0 w-full overflow-y-auto">
    <div @opacity *ngIf="stepsForDisplay().length === 0">
      <pl-menu-item
        *ngFor="let module of modulesForDisplay()"
        class="block w-full border-y border-white"
        [backgroundColor]="module | menuItemBackgroundColor: routeSlugs()"
        [iconLeft]="module.menuItem.iconLeft"
        [iconLeftColor]="module.menuItem.iconLeftColor"
        [iconRight]="module | menuItemChevron: routeSlugs()"
        [isLocked]="module.menuItem.isLocked"
        [orangeSubtitle]="module.menuItem.orangeSubtitle"
        [subtitle]="module.menuItem.subtitle"
        [title]="module.menuItem.title"
        (click)="showSteps(module.steps)"
      />
      <ng-container *ngTemplateOutlet="menuItemLogout" />
    </div>
  </div>

  <div @translateX *ngIf="stepsForDisplay().length !== 0" class="absolute bottom-0 top-0 w-full overflow-y-auto">
    <pl-menu-item
      *ngFor="let step of stepsForDisplay()"
      class="block w-full border-y border-white"
      [backgroundColor]="step | menuItemBackgroundColor: routeSlugs()"
      [description]="step.menuItem.description"
      [iconLeft]="step.menuItem.iconLeft"
      [iconLeftColor]="step.menuItem.iconLeftColor"
      [iconRight]="step | menuItemChevron: routeSlugs()"
      [isLocked]="step.menuItem.isLocked"
      [orangeSubtitle]="step.menuItem.orangeSubtitle"
      [subtitle]="step.menuItem.subtitle"
      [title]="step.menuItem.title"
      (click)="goToStep(step.link, $event)"
    />
    <ng-container *ngTemplateOutlet="menuItemLogout" />
  </div>
</div>

<ng-template #menuItemLogout>
  <pl-menu-item
    class="block h-20 w-full border-y border-white"
    [backgroundColor]="BackgroundColor.gray500"
    [iconLeft]="PlIcon.log_out"
    [title]="'utils.logout' | translate"
    (click)="logout()"
  />
</ng-template>
